import { Component, effect, inject, signal } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DocumentFormBase } from '../document-form.base';
import { dateValiditePjErrors } from '@lib/validators/date-validition-pj-errors-validators';
import { dateDebutDejaValideeValidator } from '@lib/validators/date-debut-deja-validee.validator';
import { DocumentsConsultantService } from '@lib/services/documents/documents-consultant.service';
import { PieceJustificativeDocumentTypeEnum } from '@graphql/generated';
import { OuiDatePicker, OuiValidationError } from 'omnium-ui/form-field';

const NOTIF_AFF_DOCUMENT_TYPES = [
  PieceJustificativeDocumentTypeEnum.NotifAffiliationAgc,
  PieceJustificativeDocumentTypeEnum.NotifAffiliationPl,
  PieceJustificativeDocumentTypeEnum.NotifAffiliationSoc,
];

@Component({
  selector: 'app-document-form-notif-aff',
  standalone: true,
  imports: [OuiDatePicker],
  templateUrl: './document-form-notif-aff.component.html',
  styleUrl: './document-form-notif-aff.component.scss',
})
export class DocumentFormNotifAffComponent extends DocumentFormBase<NotifAffForm> {
  private readonly documentsConsultantService = inject(DocumentsConsultantService);
  private readonly datesDebutValidees = signal<string[]>([]);

  readonly dateValidationErrors: OuiValidationError[] = dateValiditePjErrors();

  constructor() {
    super();
    this.form.controls.dateDebutValidite.addValidators(
      dateDebutDejaValideeValidator(this.datesDebutValidees)
    );

    // codeConsultant is only set when the document is editable
    effect(() => {
      if (this.codeConsultant()) {
        this.loadDatesDebutValidees();
      }
    });
  }

  override createForm(fb: NonNullableFormBuilder) {
    return createNotifAffForm(fb);
  }

  setDateFinDeValidite(newDate: moment.Moment | string | null) {
    if (newDate != null && typeof newDate != 'string') {
      this.form.get('dateFinValidite')?.setValue(undefined);
    }
  }

  private async loadDatesDebutValidees() {
    this.datesDebutValidees.set(
      await this.documentsConsultantService.getDatesDebutValiditeValidees(
        NOTIF_AFF_DOCUMENT_TYPES
      )
    );
    this.form.controls.dateDebutValidite.updateValueAndValidity();
  }
}

export function createNotifAffForm(fb: NonNullableFormBuilder) {
  return fb.group({
    dateDebutValidite: fb.control<Date | undefined>(undefined, [Validators.required]),
    dateFinValidite: fb.control<Date | undefined>(undefined),
  });
}

export type NotifAffForm = ReturnType<typeof createNotifAffForm>;
export type NotifAffFormValue = NotifAffForm['value'];
